import { doc, getDoc } from "firebase/firestore";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import VideoModal from "../../components/VideoModal/VideoModal";

export const allLinks = {
  "/prepare-for-boarding": {
    route: "/",
    link: "media=1&yaw=-0.70&pitch=15.28",
  },
  "/enter-space-shuttle": {
    route: "/enter-space-shuttle",
    link: "media=3&yaw=2.40&pitch=11.73&son=Video,Video,Video",
  },
  "/en-route-to-space": {
    route: "/en-route-to-space",
    link: "media=5&yaw=-35.72&pitch=-12.17&son=Video",
  },
  "/the-lunar-experience": {
    route: "/the-lunar-experience",
    link: "media=6&yaw=-13.31&pitch=-19.71",
  },
  "/space-shuttle": {
    route: "/space-shuttle",
    link: "media=4&yaw=2.22&pitch=11.73&son=Video",
  },
};

const ThreedScene = ({ db }) => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [videoData, setVideoData] = useState({
    play: false,
    url: null,
  });
  const [data, setData] = useState(null);
  let navigate = useNavigate();
  const query = searchParams.get("url");

  useEffect(() => {
    if (query) {
      // navigate("media=4&yaw=2.22&pitch=11.73&son=Video", { replace: true });
      setVideoData({ play: true, url: query });
    }

    // if (searchParams ==={ url: videoData.url } )
  }, [query, navigate]);

  const rightVideo = useCallback(() => {
    if (data) {
      navigate("/space-shuttle", { replace: true });

      setVideoData({
        play: true,
        url: data.rightVideo,
      });
    }
  }, [data, navigate]);

  const leftVideo = useCallback(() => {
    navigate("/space-shuttle", { replace: true });

    if (data) {
      setVideoData({
        play: true,
        url: data.leftVideo,
      });
    }
  }, [data, navigate]);

  const NextClick = useCallback(() => {
    window.history.replaceState({}, null, "/lunar-experience");
    // navigate("/brand-experience", { replace: true });
  }, []);

  const videoEnd = useCallback(() => {
    // console.log("videoend");
    navigate("/brand-experience", { replace: true });
  }, [navigate]);

  useEffect(() => {
    window.parent.RightVideo = rightVideo;
    window.parent.LeftVideo = leftVideo;
    window.parent.VideoEnd = videoEnd;
    window.parent.RightScreenClick = NextClick;
  }, [rightVideo, leftVideo, videoEnd, NextClick]);

  const fetchData = useCallback(async () => {
    const docRef = doc(db, "backstage", "static_links");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setData(docSnap.data());
    } else {
      // console.log("No such document!");
    }
  }, [db]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleModalClose = () => {
    setVideoData({ play: false, url: null });
  };

  const device = window.innerWidth < 720 ? "phone" : "Desktop";

  return (
    <div>
      <iframe
        src={
          pathname === "/"
            ? `/threed/index.htm`
            : `/threed/index.htm#${allLinks[pathname]?.link}`
        }
        title="penfold"
        allow="camera; microphone; autoplay"
        width="100%"
        height="100%"
        frameBorder="0"
        style={{
          height: "100%",
          width: "100%",
          zIndex: 2,
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      ></iframe>
      {videoData.play && (
        <VideoModal videoData={videoData} handleModalClose={handleModalClose} />
      )}
    </div>
  );
};

export default ThreedScene;
